import { AnchorMiddleware } from './anchor';

export default AnchorMiddleware;
